// Contact.country stores ISO 3166-1 alpha-2 codes (django-countries CountryField).
export const CONTACT_COUNTRIES = [
  { code: "ZW", name: "Zimbabwe" },
  { code: "ZA", name: "South Africa" },
  { code: "ZM", name: "Zambia" },
  { code: "MW", name: "Malawi" },
  { code: "BW", name: "Botswana" },
  { code: "NA", name: "Namibia" },
];

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

// Display name for a stored code; falls back to the raw value so legacy text still shows.
export const countryName = (code?: string | null): string => {
  if (!code) return "";
  if (code.length !== 2) return code;
  try {
    return regionNames.of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
};
